module.exports = __webpack_public_path__ + "static/img/20221018.773eda9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20221018.png
// module id = Nkr/
// module chunks = 3